<nz-space class="mobile-report-control">
    <app-stock-transfer-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
      valueField="docCode">
    </app-stock-transfer-select>
    <span class="text-center">
      <span nz-icon nzType="swap-right" nzTheme="outline"></span>
    </span>
    <app-stock-transfer-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)" valueField="docCode">
    </app-stock-transfer-select>
  </nz-space>
  